import type { TaskResult } from "../types";

const INVENTORY_SHEET = "Inventario de alimentos";
const ORGANIC_SHEET = "Alimentos orgánicos";

export async function gradeProject18(): Promise<TaskResult[]> {
  const results: TaskResult[] = [];

  // Tarea 1: Verificar que se importó AlimentoMascotas.txt como tabla en nueva hoja
  try {
    await Excel.run(async (context) => {
      const sheets = context.workbook.worksheets;
      sheets.load("items/name");
      await context.sync();

      // Buscar una hoja que NO sea las dos originales ni "Hoja1"
      const knownSheets = [INVENTORY_SHEET, ORGANIC_SHEET, "Hoja1"];
      const newSheets = sheets.items.filter(
        (s) => !knownSheets.includes(s.name),
      );

      let passed = false;
      for (const sheet of newSheets) {
        const tables = sheet.tables;
        tables.load("items");
        await context.sync();

        if (tables.items.length > 0) {
          // Verificar que la tabla contenga datos del archivo (artículo 100001)
          const dataRange = tables.items[0].getDataBodyRange();
          dataRange.load("values");
          await context.sync();

          const allValues = dataRange.values.flat().map((v) => String(v));
          if (allValues.some((v) => v.includes("100001") || v.includes("Alimento para perro"))) {
            passed = true;
            break;
          }
        }
      }

      results.push({ taskId: 1, passed });
    });
  } catch (e) {
    console.error("[P18-T1] ERROR:", e);
    results.push({ taskId: 1, passed: false });
  }

  // Tarea 2: Verificar que C27 tiene texto pero NO hipervínculo
  try {
    await Excel.run(async (context) => {
      const sheet = context.workbook.worksheets.getItem(INVENTORY_SHEET);
      const cell = sheet.getRange("C27");
      cell.load("values,hyperlink");
      await context.sync();

      const value = String(cell.values[0][0] ?? "").trim();
      const hyperlink = cell.hyperlink?.address ?? cell.hyperlink?.documentReference ?? "";
      results.push({
        taskId: 2,
        passed: value.length > 0 && !hyperlink,
      });
    });
  } catch {
    results.push({ taskId: 2, passed: false });
  }

  // Tarea 3: Verificar que no hay formato condicional en D4:D25
  try {
    await Excel.run(async (context) => {
      const sheet = context.workbook.worksheets.getItem(INVENTORY_SHEET);
      const formats = sheet.getRange("D4:D25").conditionalFormats;
      formats.load("items");
      await context.sync();

      results.push({ taskId: 3, passed: formats.items.length === 0 });
    });
  } catch {
    results.push({ taskId: 3, passed: false });
  }

  // Tarea 4: Verificar tabla en Alimentos orgánicos A3:F10 con estilo medio 7
  try {
    await Excel.run(async (context) => {
      const sheet = context.workbook.worksheets.getItem(ORGANIC_SHEET);
      const tables = sheet.tables;
      tables.load("items");
      await context.sync();

      let passed = false;
      if (tables.items.length > 0) {
        const table = tables.items[0];
        table.load("style");
        const range = table.getRange();
        range.load("address");
        await context.sync();

        passed =
          String(range.address).replace(/\$/g, "").toUpperCase().includes("A3:F10") &&
          String(table.style).toUpperCase().includes("MEDIUM7");
      }

      results.push({ taskId: 4, passed });
    });
  } catch {
    results.push({ taskId: 4, passed: false });
  }

  // Tarea 5: Verificar estilo 11 en el gráfico
  try {
    await Excel.run(async (context) => {
      const sheet = context.workbook.worksheets.getItem(INVENTORY_SHEET);
      const chart = sheet.charts.getItemAt(0);
      chart.load("style");
      await context.sync();

      // Debug: ver qué valor tiene el estilo actual
      console.log("[P18-T5] chart.style:", chart.style);
      // Estilo 11 en la UI puede mapear a diferentes valores internos
      // Aceptar 11 o 211 (depende de la versión)
      const style = Number(chart.style);
      results.push({ taskId: 5, passed: style === 261 });
    });
  } catch (e) {
    console.error("[P18-T5] ERROR:", e);
    results.push({ taskId: 5, passed: false });
  }

  return results;
}
